import isCi from 'is-ci';
import logger from './logger';

export default function logForCI(...args: unknown[]) {
  logger.info({ args }, 'logForCI');

  if (isCi || !process.stdin.isTTY) {
    console.info(...args);
  }
}
